import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

const GAMES = [
  {
    id: 'lightspeed',
    to: '/lightspeed',
    title: 'LightSpeed',
    subtitle: 'Réflexes',
    description: '5 feux s\'allument puis s\'éteignent. Appuie sur GO le plus vite possible. Chaque milliseconde compte.',
    tiers: [
      { label: '< 0.3s', xp: '1 000 XP', color: '#e10600' },
      { label: '< 0.4s', xp: '400 XP',   color: '#f97316' },
      { label: '< 1.0s', xp: '100 XP',   color: '#a3e635' },
      { label: 'Faux départ', xp: '−1 000 XP', color: '#52525b' },
    ],
    visual: (
      <div className="flex items-center justify-center gap-3 py-2">
        {[1,2,3,4,5].map(i => (
          <div key={i} className={`w-8 h-8 rounded-full border-2 transition-all ${
            i <= 3
              ? 'bg-red-600 border-red-400'
              : 'bg-zinc-800 border-zinc-700'
          }`}
          style={i <= 3 ? { boxShadow: '0 0 12px 4px rgba(225,6,0,0.5)' } : {}} />
        ))}
      </div>
    ),
    accentColor: '#e10600',
    label: 'RÉFLEXES',
  },
  {
    id: 'cirquiz',
    to: '/quiz',
    title: 'CirQuiz',
    subtitle: 'Circuits',
    description: 'Un tracé de circuit s\'affiche avec 3 choix. Identifie tous les circuits le plus vite possible. Circuits ratés ? Ils reviennent jusqu\'à les trouver.',
    tiers: [
      { label: '< 20 sec', xp: '2 000 XP', color: '#e10600' },
      { label: '< 30 sec', xp: '1 000 XP', color: '#f97316' },
      { label: '< 1 min',  xp: '250 XP',   color: '#facc15' },
      { label: '< 1 min 30', xp: '100 XP', color: '#a3e635' },
    ],
    visual: (
      <div className="flex items-center justify-center gap-2 py-2">
        {['🇦🇺','🇲🇨','🇬🇧','🇮🇹','🇯🇵'].map((flag, i) => (
          <span key={i} className="text-2xl" style={{ opacity: i === 2 ? 1 : 0.35 }}>{flag}</span>
        ))}
      </div>
    ),
    accentColor: '#22c55e',
    label: 'QUIZ',
  },
  {
    id: 'podiumquiz',
    to: '/podium',
    title: 'PodiumQuiz',
    subtitle: 'Podiums',
    description: 'Un GP (2022–2025) s\'affiche. Reconstitue le podium P1 / P2 / P3 en glissant les pilotes. 0/6 = Game Over.',
    tiers: [
      { label: '≥ 36 pts', xp: '1 500 XP', color: '#facc15' },
      { label: '≥ 18 pts', xp: '600 XP',   color: '#fb923c' },
      { label: '≥ 6 pts',  xp: '150 XP',   color: '#a3e635' },
    ],
    visual: (
      <div className="flex items-end justify-center gap-2 py-1">
        {[
          { pos: 'P2', h: 'h-10', color: '#94a3b8' },
          { pos: 'P1', h: 'h-14', color: '#facc15' },
          { pos: 'P3', h: 'h-8',  color: '#fb923c' },
        ].map(({ pos, h, color }) => (
          <div key={pos} className={`flex flex-col items-center gap-1`}>
            <span className="text-[10px] font-black" style={{ color }}>{pos}</span>
            <div className={`w-10 ${h} rounded-t-sm`} style={{ backgroundColor: `${color}33`, border: `2px solid ${color}66` }} />
          </div>
        ))}
      </div>
    ),
    accentColor: '#facc15',
    label: 'PODIUMS',
  },
  {
    id: 'grille',
    to: '/grille',
    title: 'Grille de Départ',
    subtitle: 'Qualifications',
    description: 'Un GP de 2022 à 2025 s\'affiche. Remets les pilotes dans l\'ordre exact de la grille de départ (résultats des qualifications). 100 XP par bonne position, 1 défi par jour.',
    tiers: [
      { label: '20/20',   xp: '2 000 XP', color: '#06b6d4' },
      { label: '15/20',   xp: '1 500 XP', color: '#22d3ee' },
      { label: '10/20',   xp: '1 000 XP', color: '#67e8f9' },
      { label: '1/20',    xp: '100 XP',   color: '#6b7280' },
      { label: '1×/jour', xp: '',          color: '#e10600' },
    ],
    visual: (
      <div className="flex flex-col gap-1 py-1">
        {[{pos:'P1',c:'#06b6d4'},{pos:'P2',c:'#22d3ee'},{pos:'P3',c:'#67e8f9'},{pos:'P4',c:'#6b7280'}].map(({pos,c}) => (
          <div key={pos} className="flex items-center gap-2">
            <span className="text-[10px] font-black w-5" style={{color:c}}>{pos}</span>
            <div className="h-2 rounded-full flex-1" style={{backgroundColor:`${c}33`, border:`1px solid ${c}66`}} />
          </div>
        ))}
      </div>
    ),
    accentColor: '#06b6d4',
    label: 'POSITIONS',
  },
  {
    id: 'guess',
    to: '/guess',
    title: 'Qui Suis-Je ?',
    subtitle: 'Pilote',
    description: 'Un pilote F1 est tiré au sort. Des indices te sont donnés un par un. Propose son nom : plus tu trouves tôt, plus tu gagnes de XP. Joue autant que tu veux !',
    tiers: [
      { label: '1er indice', xp: '1 000 XP', color: '#a855f7' },
      { label: '2e indice',  xp: '900 XP',   color: '#c084fc' },
      { label: '4e indice',  xp: '700 XP',   color: '#d8b4fe' },
      { label: 'Trouvé',     xp: '≥ 100 XP', color: '#6b7280' },
      { label: '1×/jour',   xp: '',           color: '#e10600' },
    ],
    visual: (
      <div className="flex flex-col items-center justify-center gap-2 py-2">
        <div className="text-3xl">🕵️</div>
        <div className="flex gap-1">
          {[1,2,3,4,5,6].map(i => (
            <div key={i} className="h-1.5 w-5 rounded-full" style={{ backgroundColor: i <= 2 ? '#a855f7' : '#3f3f46' }} />
          ))}
        </div>
        <p className="text-[9px] text-zinc-500 font-bold uppercase tracking-wider">Indices révélés</p>
      </div>
    ),
    accentColor: '#a855f7',
    label: 'QUI SUIS-JE ?',
  },
  {
    id: 'gap',
    to: '/gap',
    title: 'Le Gap',
    subtitle: 'Écart',
    description: 'Deux pilotes d\'une même course s\'affichent. Estime l\'écart de temps entre eux en secondes. 5 manches par course. Joue autant que tu veux !',
    tiers: [
      { label: '±10%',  xp: '1 000 XP', color: '#f59e0b' },
      { label: '±25%',  xp: '800 XP',   color: '#fbbf24' },
      { label: '±50%',  xp: '600 XP',   color: '#fcd34d' },
      { label: '±100%', xp: '300 XP',   color: '#6b7280' },
    ],
    visual: (
      <div className="flex flex-col items-center justify-center gap-2 py-1">
        <div className="text-3xl">⏱️</div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-amber-400 font-black">P3</span>
          <span className="text-zinc-600 font-black">↔</span>
          <span className="text-zinc-400 font-black">P7</span>
        </div>
        <p className="text-[9px] text-zinc-500 font-bold uppercase tracking-wider">Estime l'écart</p>
      </div>
    ),
    accentColor: '#f59e0b',
    label: 'LE GAP',
  },
  {
    id: 'lead',
    to: '/lead',
    title: 'Qui Menait ?',
    subtitle: 'Leaders',
    description: 'Un tour de course s\'affiche. Qui était en tête à ce moment-là ? 4 pilotes proposés, 10 questions par course. Données réelles via API. Joue autant que tu veux !',
    tiers: [
      { label: '10/10', xp: '1 000 XP', color: '#3b82f6' },
      { label: '7/10',  xp: '700 XP',   color: '#60a5fa' },
      { label: '4/10',  xp: '400 XP',   color: '#93c5fd' },
      { label: '1/10',  xp: '100 XP',   color: '#6b7280' },
    ],
    visual: (
      <div className="flex flex-col items-center justify-center gap-2 py-1">
        <div className="text-3xl">🏁</div>
        <div className="flex items-center gap-1 text-[10px]">
          <span className="text-blue-400 font-black">Tour 42</span>
          <span className="text-zinc-600">·</span>
          <span className="text-zinc-400">Qui mène ?</span>
        </div>
        <p className="text-[9px] text-zinc-500 font-bold uppercase tracking-wider">4 choix</p>
      </div>
    ),
    accentColor: '#3b82f6',
    label: 'QUI MENAIT ?',
  },
  {
    id: 'the-race',
    to: '/the-race',
    title: 'The Race',
    subtitle: 'Plateau F1',
    description: 'Jeu de plateau multijoueur tour par tour. 50 cases autour d\'un circuit, un dé, des cases pièges et bonus. Premier à franchir la ligne gagne 1 000 XP !',
    tiers: [
      { label: '1er', xp: '1 000 XP', color: '#FFD600' },
      { label: '2e',  xp: '600 XP',   color: '#A8A8B3' },
      { label: '3e',  xp: '300 XP',   color: '#CD7F32' },
    ],
    visual: (
      <div className="flex flex-col items-center justify-center gap-1.5 py-1">
        <div className="text-3xl">🏎</div>
        <div className="flex gap-1">
          {['🚀','🚧','⚡','💥','🔧'].map((e, i) => (
            <span key={i} className="text-sm">{e}</span>
          ))}
        </div>
        <p className="text-[9px] text-zinc-500 font-bold uppercase tracking-wider">50 cases · tour par tour</p>
      </div>
    ),
    accentColor: '#e10600',
    label: 'PLATEAU',
  },
  {
    id: 'saison',
    to: '/saison',
    title: 'Champion de saison',
    subtitle: 'Pronostics',
    description: 'Qui remporte le championnat ? Fais ton pronostic en début de saison et suis l\'évolution au fil des GP.',
    tiers: [
      { label: 'Correct dès le départ', xp: '2 000 XP', color: '#a855f7' },
      { label: 'Correction tardive',    xp: '500 XP',   color: '#7c3aed' },
    ],
    visual: (
      <div className="flex items-center justify-center gap-3 py-2">
        <Icon name="trophy" size={40} />
        <div className="text-left">
          <p className="text-white font-black text-sm leading-none">WCC</p>
          <p className="text-white font-black text-sm leading-none">WDC</p>
          <p className="text-zinc-500 text-xs mt-1">2026</p>
        </div>
      </div>
    ),
    accentColor: '#a855f7',
    label: 'SAISON',
  },
];

const BoxBoxHub = () => (
  <div className="max-w-6xl mx-auto px-4 py-10">
    {/* Header */}
    <div className="mb-10 relative">
      <div className="speed-divider mb-5 w-24" />
      <p className="f1-label mb-2">Mini-jeux F1</p>
      <h1 className="text-5xl md:text-7xl font-black text-white tracking-tight leading-none">
        BOX<span className="text-f1red">—</span>BOX
      </h1>
      <p className="text-zinc-400 mt-3 text-base max-w-lg">
        Prouve tes connaissances F1. Chaque jeu rapporte de l'XP pour progresser dans ton classement.
      </p>
    </div>

    {/* Game cards grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {GAMES.map(game => (
        <div key={game.id} className="group relative overflow-hidden rounded-lg border border-zinc-800/80 bg-[#0e0e12]
          hover:border-zinc-700 transition-all duration-200 hover:-translate-y-1 hover:shadow-2xl"
          style={{ '--accent': game.accentColor }}>

          {/* Top accent bar */}
          <div className="h-[3px] w-full" style={{ background: `linear-gradient(90deg, ${game.accentColor} 0%, transparent 70%)` }} />

          <div className="p-6">
            {/* Label + title row */}
            <div className="flex items-start justify-between mb-4">
              <div>
                <span className="text-[10px] font-black tracking-[0.25em] uppercase mb-1 block"
                  style={{ color: game.accentColor }}>{game.label}</span>
                <h2 className="text-3xl font-black text-white leading-none">{game.title}</h2>
              </div>
              {/* Visual */}
              <div className="shrink-0 ml-4 w-32">
                {game.visual}
              </div>
            </div>

            {/* Description */}
            <p className="text-zinc-400 text-sm leading-relaxed mb-5">{game.description}</p>

            {/* XP tiers */}
            <div className="flex flex-wrap gap-1.5 mb-6">
              {game.tiers.map(t => (
                <span key={t.label} className="text-[11px] font-bold px-2 py-0.5 rounded-sm border"
                  style={{ color: t.color, borderColor: `${t.color}44`, background: `${t.color}10` }}>
                  {t.label} → {t.xp}
                </span>
              ))}
            </div>

            {/* CTA */}
            <Link to={game.to} className="btn-primary w-full py-3 text-center block text-sm">
              Jouer maintenant →
            </Link>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default BoxBoxHub;
